import { useEffect, useState } from 'react'

import { getContractorMapping } from '../../../api'
import { EMPTY_OBJECT } from '../../../constants/common'
import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { SIZE } from '../../../constants/size'
import { useNotification } from '../../../hooks'
import { FormModal } from '../../Form'
import { useResizeModal } from '../../Modal'

import {
  getAllMappedBuildingOptions,
  getAllMappedCategoryOptions,
} from './EditBuildingAndCategoryModal.api'
import { QA_NAME_EDIT_BUILDING_AND_CATEGORY_MODAL } from './EditBuildingAndCategoryModal.constants'
import {
  getInitialValues,
  getValidationSchema,
} from './EditBuildingAndCategoryModal.utils'
import { EditBuildingAndCategoryModalFormBody } from './EditBuildingAndCategoryModalFormBody'
import { EditBuildingAndCategoryModalFormFields } from './EditBuildingAndCategoryModalFormFields'

import * as styles from './EditBuildingAndCategoryFormModal.module.css'

function EditBuildingAndCategoryModal({
  formFieldsProps = EMPTY_OBJECT,
  id,
  name,
  onCloseModal,
  onSubmit,
}) {
  const { handleAddErrorNotification } = useNotification()

  const { fullScreen, handleResizeModal } = useResizeModal()

  const [initialValues, setInitialValues] = useState(getInitialValues(null))
  const [isLoading, setLoading] = useState(Boolean(id))

  useEffect(() => {
    if (id) {
      Promise.all([
        getAllMappedBuildingOptions({ contractor: id }),
        getAllMappedCategoryOptions({ contractor: id }),
        getContractorMapping(id),
      ])
        .then(([buildingsRes, categoriesRes, mappingRes]) => {
          setInitialValues(
            getInitialValues({
              buildingsObjects: buildingsRes?.data?.results?.objects,
              categoriesObjects: categoriesRes?.data?.results?.objects,
              mapping: mappingRes?.data?.mapping,
            })
          )
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])

  const validationSchema = getValidationSchema({
    initialValues,
    isItemAction: Boolean(id),
  })

  return (
    <FormModal
      Fields={EditBuildingAndCategoryModalFormFields}
      FormBody={EditBuildingAndCategoryModalFormBody}
      containerProps={{
        boxSize: SIZE.LARGE,
        isFullScreen: fullScreen,
        qaName: QA_NAME_EDIT_BUILDING_AND_CATEGORY_MODAL,
        onResize: handleResizeModal,
      }}
      formBodyProps={{
        ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
        contentClassName: styles.content,
        contentProps: {
          contentWrapperClassName: styles.contentWrapper,
          isFullScreen: fullScreen,
          size: SIZE.LARGE,
        },
        isLoading,
      }}
      formFieldsProps={{ ...formFieldsProps, isLoading, name }}
      formTitle='Modal.ChangeBuildingAndCategoryTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onCloseModal}
      onSubmit={onSubmit}
    />
  )
}

export default EditBuildingAndCategoryModal
